import { render, staticRenderFns } from "./SwitcherComponent.vue?vue&type=template&id=5bc60aa3&scoped=true"
import script from "./SwitcherComponent.vue?vue&type=script&lang=js"
export * from "./SwitcherComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc60aa3",
  null
  
)

export default component.exports